const styles = (theme) => ({
  root: {
    width: '100%',
    position: 'absolute',
    bottom: '0',
    zIndex: 3,
    pointerEvents: 'none',
  },

  container: {
    ...theme.box,
    borderRadius: '9px',
    border: 'none',
    boxShadow:
      '0px 1px 3px 0px rgba(89, 97, 104, 0.15), 0px 3px 15px 0px rgba(89, 97, 104, 0.2)',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '440px',
    maxWidth: '90vw',
    background: 'white',
    padding: '16px 24px 20px',
    marginBottom: '24px',
    position: 'relative',
    pointerEvents: 'auto',
  },

  nps: {
    '&-enter': {
      opacity: 0,
    },

    '&-enter-active': {
      opacity: 1,
      transition: 'opacity 300ms ease-in',
    },

    '&-leave': {
      opacity: 1,
    },

    '&-leave-active': {
      opacity: 0,
      transition: 'opacity 300ms, transform 300ms',
      transform: 'translateY(100%)',
    },
  },

  headline: {
    display: 'inline-block',
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: '12px',
    color: 'rgb(20, 140, 252)',
  },

  headlineGray: {
    color: 'rgb(123, 139, 153)',
  },

  surveyQuestion: {
    color: 'rgb(20, 140, 252)',
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: '10px',
  },

  input: {
    marginBottom: '16px',
  },

  scores: {
    width: '100%',
    display: 'flex',
  },

  surveyExpanded: {
    marginBottom: '20px',
  },

  scoreOption: {
    display: 'inline-block',
    borderRadius: '50%',
    backgroundColor: '#f0f4f8',
    color: 'rgb(155, 173, 188)',
    padding: '5px',
    fontSize: '16px',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    marginRight: '8px',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    transition: 'transform ease .2s',

    '&:hover': {
      transform: 'scale(1.1)',
    },

    '&:last-child': {
      marginRight: 0,
    },
  },

  selectedScoreOption: {
    background:
      'linear-gradient(-225deg, rgb(77, 177, 253) 0%, rgb(20, 140, 252) 100%)',
    color: '#fff',
    fontWeight: '500',
  },

  close: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    padding: '15px',
    lineHeight: '10px',
    cursor: 'pointer',
  },

  successMessageText: {
    marginBottom: '20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    maxWidth: '260px',
    fontSize: '15px',
    lineHeight: '18px',
    fontWeight: 500,
    color: 'rgb(123, 139, 153)',
  },

  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(20, 140, 252, 0.5)',
    },

    '70%': {
      boxShadow: '0 0 0 15px rgba(20, 140, 252, 0)',
    },

    '100%': {
      boxShadow: '0 0 0 0 rgba(20, 140, 252, 0)',
    },
  },

  successScore: {
    marginLeft: 'auto',
    marginRight: 'auto',
    margin: '10px 20px 20px',
    textAlign: 'center',
    fontSize: '22px',
    lineHeight: '50px',
    borderRadius: '50%',
    height: '50px',
    width: '50px',
    color: '#fff',
    background:
      'linear-gradient(-225deg, rgb(77, 177, 253) 0%, rgb(20, 140, 252) 100%)',
    animation: 'pulse 2s infinite',
  },
});

export default styles;
